import { useSensitiveRevealStore } from '~/store/sensitive-reveal.store';

import { createSensitiveMasker, maskCached } from '../utils/mask-sensitive';

type Id = string | null | undefined;

/**
 * Read-time masking bound to the session "reveal sensitive data" switch.
 * `preserve` = ids that always stay readable (the inspected execution's own
 * ids); `mask(value, extra)` adds per-response ids the UI navigates or calls
 * APIs with (a Temporal run id, child workflow ids…) — masking those would
 * break the follow-up request. With reveal on, values pass through untouched.
 */
export function useSensitiveMask(preserve: Id[] = []) {
  const reveal = useSensitiveRevealStore((s) => s.revealSensitive);
  return {
    reveal,
    mask: <T>(value: T, extra: Id[] = []): T =>
      reveal ? value : maskCached(value, [...preserve, ...extra]),
    maskText: (text: string): string =>
      reveal ? text : createSensitiveMasker(preserve).maskText(text),
  };
}
